import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: string;
  onSort: (property: string) => void;
}

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: string) => () => {
    onSort(property);
  };

  return (
    <TableHeader>
      
      <TableCell sortDirection={orderBy === "planGroupCode" ? order : false} align="left"  sx={{ fontSize: 14 }}>
        <TableSortLabel
          active={orderBy === "planGroupCode"}
          direction={orderBy === "planGroupCode" ? order : "asc"}
          onClick={createSortHandler("planGroupCode")}
        >
          Plan Group Code
        </TableSortLabel>
      </TableCell>

      <TableCell sortDirection={orderBy === "groupCount" ? order : false} align="left"  sx={{ fontSize: 14 }}>
        <TableSortLabel
          active={orderBy === "groupCount"}
          direction={orderBy === "groupCount" ? order : "asc"}
          onClick={createSortHandler("groupCount")}
        >
         Plans Count
        </TableSortLabel>
      </TableCell>

     

      <TableCell align="right"  sx={{ fontSize: 14 }}>Action</TableCell>
    </TableHeader>
  );
};

export default TableHeading;
